export const getConfidenceLevelColor = (
  num: number
): 'green' | 'orange' | 'red' | undefined => {
  if (num >= 7 && num <= 10) return 'green';
  if (num >= 4 && num < 7) return 'orange';
  if (num >= 1 && num < 4) return 'red';
};
